/* by morning · Zigzag quantity bundles. Uses the theme's own product form. */
(()=>{
  if(customElements.get('bm-zigzag-bundle'))return;
  function setup(root){
    const config=JSON.parse(root.querySelector('[data-zz-config]').textContent);
    const scope=root.closest('product-info')||root.closest('.shopify-section');
    if(!scope)return;
    const form=[...scope.querySelectorAll('form[data-product-form]')].find(candidate=>config.variants[candidate.elements.namedItem('id')?.value]);
    const nativeButton=form?.querySelector('[data-add-to-cart]');
    if(!form||!nativeButton)return;
    const appearance=getComputedStyle(nativeButton);
    root.querySelectorAll('.zz-buy').forEach(button=>{button.style.borderRadius=appearance.borderRadius;button.style.paddingBlock=appearance.paddingBlock;});
    const nativeButtons=form.querySelector('.product__submit__buttons');
    const originalDisplay=nativeButtons?.style.display||'';
    // Keep the native product-form wrapper enclosing the visible purchase area;
    // its dimensions also determine the theme's sticky cart-bar behavior.
    if(root.parentNode!==form.parentNode)form.before(root);
    const controller=new AbortController(),signal=controller.signal;
    const on=(target,event,callback,options={})=>target.addEventListener(event,callback,{...options,signal});
    const cards=[...root.querySelectorAll('[data-bundle]')];
    const offers=cards.map(card=>({quantity:Number(card.dataset.quantity),discount:Number(card.dataset.discount)}));
    const stack=root.querySelector('.zz-stack'),pencil=root.querySelector('.zz-pencil'),pencilStroke=pencil.querySelector('path');
    const panels=cards.map(card=>card.querySelector('.zz-panel'));
    const headers=cards.map(card=>card.querySelector('.zz-toggle'));
    const benefits=cards.map(card=>card.querySelector('.zz-benefits'));
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    const design={motion:config.motion,draw:config.draw,corner:config.corner};
    const state={index:1,subscription:!!config.requiresSellingPlan,frequency:String(config.defaultPlan||'')};
    const inkAnimations=[];
    let inkRoute=null,railWidth=0,selectionVersion=0,benefitVersion=0,layoutVersion=0,settleFrame=0,benefitFrame=0,disposed=false;
    const money=cents=>{
      const formatter=window.theme?.formatMoney||window.Shopify?.formatMoney;
      if(formatter)return String(formatter(Math.round(cents),config.moneyFormat)).replace(/<[^>]*>/g,'');
      return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:config.currency}).format(cents/100);
    };
    const entry=()=>config.variants[String(form.elements.namedItem('id')?.value)]||null;
    const onceTotal=offer=>Math.round((entry()?.price||0)*offer.quantity*(100-offer.discount)/100);
    const subTotal=offer=>{
      const v=entry(),allocation=v?.plans[state.frequency];
      return v?.price&&allocation!=null?Math.round(onceTotal(offer)*allocation/v.price):onceTotal(offer);
    };
    const total=offer=>state.subscription?subTotal(offer):onceTotal(offer);
    function validPlans(){
      const plans=entry()?.plans||{};
      return [...cards[0].querySelector('select').options].filter(option=>plans[option.value]!=null);
    }
    function normalizePlan(){
      const plans=validPlans();
      if(!plans.some(option=>option.value===state.frequency))state.frequency=plans[0]?.value||'';
      if(!plans.length)state.subscription=false;
      else if(config.requiresSellingPlan)state.subscription=true;
    }
    function frequencyLabel(){return [...cards[0].querySelector('select').options].find(option=>option.value===state.frequency)?.textContent.trim()||'';}
    function announce(){
      const offer=offers[state.index];
      root.querySelector('[data-status]').textContent=offer.quantity+' pack'+(offer.quantity>1?'s':'')+', '+money(total(offer))+(state.subscription?', subscription, '+frequencyLabel():', one-time purchase');
    }
    function syncPurchase(){
      if(disposed)return;
      let quantity=form.elements.namedItem('quantity');
      if(!quantity){quantity=document.createElement('input');quantity.type='hidden';quantity.name='quantity';form.appendChild(quantity);}
      const desired=String(offers[state.index].quantity);
      if(quantity.value!==desired){quantity.value=desired;quantity.dispatchEvent(new Event('change',{bubbles:true}));}
      let plan=form.elements.namedItem('selling_plan');
      if(!plan){plan=document.createElement('input');plan.type='hidden';plan.name='selling_plan';form.appendChild(plan);}
      plan.value=state.subscription?state.frequency:'';
      plan.disabled=!state.subscription;
      const price=money(total(offers[state.index]));
      nativeButton.querySelectorAll('[data-product-price],.product__submit__value').forEach(node=>{if(node.textContent!==price)node.textContent=price;});
      nativeButton.querySelectorAll('[data-compare-price]').forEach(node=>node.classList.add('hidden'));
      const source=cards[state.index].querySelector('.zz-photo')?.src;
      if(source)scope.querySelectorAll('[data-cart-bar-image] img,.cart-bar__media img').forEach(img=>{if(img.src!==source){img.removeAttribute('srcset');img.src=source;}});
      scope.querySelectorAll('.cart-bar [data-product-price]').forEach(node=>{if(node.textContent!==price)node.textContent=price;});
    }
    function mirrorButton(){
      const available=!!entry()?.available&&(!config.requiresSellingPlan||!!state.frequency);
      const busy=nativeButton.classList.contains('is-loading');
      cards.forEach((card,i)=>{
        const button=card.querySelector('.zz-buy');
        button.disabled=i!==state.index||!available||nativeButton.disabled;
        button.classList.toggle('is-loading',busy&&i===state.index);
        button.setAttribute('aria-busy',String(busy&&i===state.index));
        card.querySelector('[data-zz-buy-label]').textContent=available?config.addLabel:config.soldOutLabel;
      });
    }
    function render(){
      normalizePlan();
      root.style.setProperty('--zz-motion',design.motion+'ms');
      root.style.setProperty('--zz-corner',design.corner+'px');
      const plans=validPlans(),v=entry();
      const saving=v?.price&&v.plans[state.frequency]!=null?Math.round(100*(1-v.plans[state.frequency]/v.price)):0;
      cards.forEach((card,i)=>{
        const active=i===state.index,offer=offers[i];
        card.dataset.open=String(active);card.dataset.subscription=String(state.subscription);
        headers[i].setAttribute('aria-expanded',String(active));
        card.querySelector('.zz-price').textContent=money(total(offer));
        card.querySelector('[data-once-price]').textContent=money(onceTotal(offer));
        card.querySelector('[data-sub-price]').textContent=money(subTotal(offer));
        card.querySelector('.zz-buy-price').textContent=money(total(offer));
        card.querySelector('[data-sub-option]').hidden=!plans.length;
        card.querySelector('[data-once-option]').hidden=!!config.requiresSellingPlan;
        card.querySelector('[data-sub-saving]').textContent=saving>0?'An extra '+saving+'% off':'';
        card.querySelector('[data-sub-benefit]').textContent=saving>0?'Extra '+saving+'% off every delivery':'Subscriber pricing on every delivery';
        card.querySelector('.zz-billing').textContent=state.subscription?frequencyLabel()+' · Cancel anytime':'One-time purchase';
        card.querySelectorAll('input[type=radio]').forEach(input=>input.checked=(input.value==='subscribe')===state.subscription);
        const select=card.querySelector('select');
        [...select.options].forEach(option=>{option.hidden=!plans.some(plan=>plan.value===option.value);option.disabled=option.hidden;});
        select.value=state.frequency;select.disabled=!active||!state.subscription;
        if(!active){panels[i].inert=true;panels[i].setAttribute('aria-hidden','true');}
        if(!state.subscription||!active){benefits[i].inert=true;benefits[i].setAttribute('aria-hidden','true');}
      });
      syncPurchase();mirrorButton();
    }
      function unlockActive(){
        panels[state.index].inert=false;
        panels[state.index].setAttribute('aria-hidden','false');
        if(state.subscription){benefits[state.index].inert=false;benefits[state.index].setAttribute('aria-hidden','false');}
      }
      // CSS transitions can reverse immediately. Only the most recent selection
      // may make its incoming controls interactive when that transition finishes.
      function settleSelection(){
        const version=++selectionVersion;
        cancelAnimationFrame(settleFrame);
        if(reduced.matches||design.motion===0){unlockActive();return;}
        settleFrame=requestAnimationFrame(()=>{
          const animations=[...panels[state.index].getAnimations(),...benefits[state.index].getAnimations()];
          Promise.allSettled(animations.map(animation=>animation.finished)).then(()=>{
            if(version===selectionVersion)unlockActive();
          });
        });
      }
      function settleBenefits(){
        const version=++benefitVersion;
        cancelAnimationFrame(benefitFrame);
        if(!state.subscription)return;
        if(reduced.matches||design.motion===0){unlockActive();return;}
        benefitFrame=requestAnimationFrame(()=>{
          const index=state.index;
          Promise.allSettled(benefits[index].getAnimations().map(animation=>animation.finished)).then(()=>{
            if(version===benefitVersion&&index===state.index&&state.subscription)unlockActive();
          });
        });
      }
      // One continuous source→destination path. Cubics are authored top→bottom,
      // then reversed (including their control points) when selection moves up.
      function updatePencilGeometry(){
        if(!inkRoute)return;
        const bounds=stack.getBoundingClientRect();
        if(!bounds.width||!bounds.height)return;
        const rects=cards.map(card=>{
          const r=card.getBoundingClientRect();
          return {left:r.left-bounds.left,right:r.right-bounds.left,top:r.top-bounds.top,bottom:r.bottom-bounds.top,width:r.width,height:r.height};
        });
        const low=Math.min(inkRoute.from,inkRoute.to),high=Math.max(inkRoute.from,inkRoute.to);
        let segments;
        if(high-low===1){
          const upper=rects[low],lower=rects[high];
          const start=[low===0?upper.left+upper.width*.36:upper.right-upper.width*.36,upper.bottom+3];
          const end=[low===0?lower.left+lower.width*.35:lower.right-lower.width*.35,lower.top-3];
          // A small oblique curl is part of the stroke itself. Its crossing is
          // made by the flowing curves, rather than a separate circular loop.
          const point=(x,y)=>[start[0]+(end[0]-start[0])*x/42,start[1]+(end[1]-start[1])*y/44];
          segments=[
            [start,point(15,0),point(24,10),point(18,18)],
            [point(18,18),point(13,25),point(3,18),point(11,12)],
            [point(11,12),point(22,3),point(42,8),end]
          ];
        }else{
          // A mirrored bow with a single continuous curl centered beside the
          // middle card. Every control point stays in its left-hand corridor,
          // including while an interrupted selection leaves that card wider.
          const upper=rects[0],middle=rects[1],lower=rects[2];
          const centerY=(middle.top+middle.bottom)/2;
          const edge=4,right=Math.max(edge+4,middle.left-8);
          const span=right-edge;
          const anchorX=Math.min(upper.width*.24,lower.width*.24,middle.left-4);
          const start=[anchorX,upper.bottom+5];
          const end=[anchorX,lower.top-5];
          const radius=Math.min(16,span*.36,middle.height*.16);
          const bendX=edge+span*.12,shoulderX=bendX+span*.12;
          const upperBend=[bendX,centerY-radius];
          const tip=[right,centerY];
          const lowerBend=[bendX,centerY+radius];
          // The two inner cubics are exact reflections: a soft teardrop curl,
          // not a circle pasted onto the line. Outer shoulders mirror as well.
          segments=[
            [start,[edge,start[1]],[edge,centerY-radius*2.5],upperBend],
            [upperBend,[shoulderX,centerY+radius*.5],[right,centerY+radius],tip],
            [tip,[right,centerY-radius],[shoulderX,centerY-radius*.5],lowerBend],
            [lowerBend,[edge,centerY+radius*2.5],[edge,end[1]],end]
          ];
        }
        if(inkRoute.from>inkRoute.to)segments=segments.reverse().map(segment=>segment.slice().reverse());
        const xy=point=>point.map(value=>value.toFixed(2)).join(' ');
        const path='M '+xy(segments[0][0])+segments.map(segment=>' C '+segment.slice(1).map(xy).join(' ')).join('');
        pencil.setAttribute('viewBox',[0,0,bounds.width,bounds.height].join(' '));
        pencil.dataset.from=String(inkRoute.from);
        pencil.dataset.to=String(inkRoute.to);
        pencilStroke.setAttribute('d',path);
      }
      function drawPencil(animate=true){
        pencil.dataset.active='false';
        inkAnimations.splice(0).forEach(animation=>animation.cancel());
        if(!inkRoute)return;
        updatePencilGeometry();
        pencil.dataset.active='true';
        if(!animate||reduced.matches||design.draw===0)return;
        const animation=pencilStroke.animate([
          {strokeDashoffset:1,offset:0},
          {strokeDashoffset:.77,offset:.22},
          {strokeDashoffset:.58,offset:.47},
          {strokeDashoffset:.32,offset:.67},
          {strokeDashoffset:0,offset:1}
        ],{duration:design.draw,delay:60,easing:'linear',fill:'backwards'});
        inkAnimations.push(animation);
      }

    headers.forEach((header,index)=>on(header,'click',()=>{
      if(index===state.index)return;
      header.focus({preventScroll:true});++benefitVersion;
      panels.forEach(panel=>{panel.inert=true;panel.setAttribute('aria-hidden','true');});
      inkRoute={from:state.index,to:index};state.index=index;
      render();settleSelection();drawPencil();announce();
    }));
    cards.forEach((card,index)=>{
      card.querySelectorAll('input[type=radio]').forEach(input=>on(input,'change',()=>{
        if(index!==state.index||!input.checked)return;
        state.subscription=input.value==='subscribe';
        benefits.forEach(panel=>{panel.inert=true;panel.setAttribute('aria-hidden','true');});
        render();settleBenefits();announce();
      }));
      on(card.querySelector('select'),'change',event=>{
        if(index!==state.index)return;
        state.frequency=event.target.value;render();announce();
      });
      on(card.querySelector('.zz-buy'),'click',()=>{
        if(index!==state.index||nativeButton.disabled||!entry()?.available)return;
        syncPurchase();
        // Native ProductForm owns validation, cart errors, drawer and loading.
        form.requestSubmit(nativeButton);
        mirrorButton();
      });
    });
      function measure(){
        const width=stack.getBoundingClientRect().width;
        if(width<=0)return;
        if(Math.abs(width-railWidth)<.25){updatePencilGeometry();return;}
        railWidth=width;
        const version=++layoutVersion;
        root.dataset.resizing='true';
        root.style.setProperty('--zz-closed',(width*.82)+'px');
        root.style.setProperty('--zz-open',(width*.92)+'px');
        drawPencil(false);
        ++selectionVersion;++benefitVersion;
        unlockActive();
        requestAnimationFrame(()=>{if(version===layoutVersion)root.dataset.resizing='false';});
      }

    root.dataset.ready='false';render();measure();unlockActive();
    if(nativeButtons)nativeButtons.style.display='none';
    const observer=new ResizeObserver(()=>{if(!disposed)measure();});
    observer.observe(stack);cards.forEach(card=>observer.observe(card));
    const buttonObserver=new MutationObserver(mirrorButton);
    buttonObserver.observe(nativeButton,{attributes:true,attributeFilter:['class','disabled']});
    requestAnimationFrame(()=>{if(!disposed)root.dataset.ready='true';});
    on(reduced,'change',()=>{
      ++selectionVersion;++benefitVersion;
      cancelAnimationFrame(settleFrame);cancelAnimationFrame(benefitFrame);
      unlockActive();drawPencil(false);
    });
    on(form,'submit',syncPurchase,{capture:true});
    on(form,'change',event=>{
      if(event.target.name==='id')queueMicrotask(()=>{if(!disposed){render();unlockActive();}});
    });
    const unsubscribers=[];
    if(window.subscribe&&window.theme?.PUB_SUB_EVENTS){
      unsubscribers.push(window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange,event=>{
        if(String(event?.data?.sectionId)!==root.dataset.sectionId)return;
        const variant=event.data.variant;
        if(variant&&config.variants[variant.id])Object.assign(config.variants[variant.id],{price:variant.price,available:variant.available});
        render();unlockActive();measure();
      }));
      unsubscribers.push(window.subscribe(window.theme.PUB_SUB_EVENTS.quantityUpdate,()=>{
        queueMicrotask(()=>{if(!disposed)syncPurchase();});
      }));
    }
    return ()=>{
      disposed=true;++selectionVersion;++benefitVersion;++layoutVersion;
      controller.abort();observer.disconnect();buttonObserver.disconnect();
      unsubscribers.forEach(unsubscribe=>unsubscribe?.());
      inkAnimations.forEach(animation=>animation.cancel());
      cancelAnimationFrame(settleFrame);cancelAnimationFrame(benefitFrame);
      if(nativeButtons)nativeButtons.style.display=originalDisplay;
    };
  }
  customElements.define('bm-zigzag-bundle',class extends HTMLElement{
    connectedCallback(){
      if(this._cleanup||this._starting)return;
      this._starting=true;
      requestAnimationFrame(()=>{
        if(this.isConnected){try{this._cleanup=setup(this);}catch(error){console.error('Bundle setup failed',error);}}
        this._starting=false;
      });
    }
    disconnectedCallback(){
      // Moving into the canonical form wrapper is intentional, not an unmount.
      if(this._starting||this.isConnected)return;
      this._cleanup?.();this._cleanup=null;
    }
  });
})();
